export var ApiNotificationResourceType;
(function (ApiNotificationResourceType) {
    ApiNotificationResourceType["DashboardComments"] = "dashboardComments";
})(ApiNotificationResourceType || (ApiNotificationResourceType = {}));
//# sourceMappingURL=notifications.js.map